import { LcsDateRange } from '@lcs/shared/core';
import { ParameterFormValueBase } from '@ndt/reports/shared/report-parameter-list/models/report-parameter-form-value';
import { ReportParameters } from 'generated/graphql-types';

export function createTimeRangeReportParameter(
   value?: TimeRangeReportParameterValue,
   sortOrder?: number | null
): TimeRangeReportParameterValue {
   let startTime: string = '09:00';
   let endTime: string = '19:00';

   if (value?.startTime) {
      startTime = value?.startTime;
   }
   if (value?.endTime) {
      endTime = value?.endTime;
   }

   const { endDate, startDate } = convertTodayTimeToDate({ startTime, endTime });

   return {
      endTime,
      sortOrder: value?.sortOrder ?? sortOrder ?? null,
      startTime,
      endDate,
      startDate,
   };
}

function isTimeOnly(value: string): boolean {
   return /^\d{2}:\d{2}$/.test(value);
}

export interface TimeRangeReportParameterValue {
   startTime?: string | null;
   endTime?: string | null;
   startDate?: Date | null;
   endDate?: Date | null;
   sortOrder: number | null;
}

export const defaultDateParameter: TimeRangeReportParameterValue = {
   endTime: null,
   //isAskParameter: false,
   sortOrder: null,
   startTime: null,
};

export interface TimeRangeParameterFormModel extends ParameterFormValueBase, TimeRangeReportParameterValue {
   parameterType: ReportParameters.TimeRange;
}

export function convertTodayTimeToDate({
   startTime,
   endTime,
}: {
   startTime?: string | null;
   endTime?: string | null;
}): LcsDateRange<Date> {
   const createLocalDate = (time?: string | null): Date | null => {
      if (!time) return null;

      const [hours, minutes] = time.split(':').map(Number);

      const d = new Date();
      d.setHours(hours, minutes, 0, 0);

      return d;
   };

   return {
      startDate: createLocalDate(startTime),
      endDate: createLocalDate(endTime),
   };
}
